module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Right Arm Sofa_Green.91762c2b.png";